/*
 * Copyright (c) 2024.
 * The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import clsx from "clsx";
import UiFilterLabel from "./Filter/UiFilterLabel";
import UiFilterButton from "./Filter/UiFilterButton";
import {ChevronLeftIcon, ChevronRightIcon} from "@heroicons/react/24/solid";
import Dates from "utils/Dates";
import {useDebouncedCallback} from "use-debounce";
import {useTranslation} from "react-i18next";

interface UiDayMovingProps {
    label?: string;
    className?: string;
    onChange: (action: "NEXT" | "PREV" | "TODAY") => void;
    disabled?: boolean;
    selected?: string | null;
}

const UiDayMoving = (props: UiDayMovingProps) => {
    const {t} = useTranslation();
    const debouncedChangeHandler = useDebouncedCallback(data => props.onChange(data), 300);
    const isSelectedCurrentDay = props.selected ? Dates.date(props.selected, "", "YYYY-MM-DD") === Dates.date(new Date(), "", "YYYY-MM-DD") : false;

    const onChangeHandler = (action: "NEXT" | "PREV" | "TODAY") => {
        debouncedChangeHandler(action);
    };

    return (
        <div className={clsx("UiDayMoving flex flex-col w-auto", props.className)}>
            {props.label && <UiFilterLabel label={props.label} />}
            <div className={"flex flex-row items-center shadow-sm shadow-black/10 rounded"}>
                <UiFilterButton
                    className={"!px-2 border-r-0"}
                    disabled={props.disabled}
                    icon={<ChevronLeftIcon className={"w-6 h-5"} />}
                    onClick={() => {
                        onChangeHandler("PREV");
                    }}
                />
                <UiFilterButton
                    active={isSelectedCurrentDay}
                    disabled={props.disabled || isSelectedCurrentDay}
                    title={t("Today")}
                    onClick={() => {
                        onChangeHandler("TODAY");
                    }}
                />
                <UiFilterButton
                    className={"!px-2 border-l-0"}
                    disabled={props.disabled}
                    icon={<ChevronRightIcon className={"w-6 h-5"} />}
                    onClick={() => {
                        onChangeHandler("NEXT");
                    }}
                />
            </div>
        </div>
    );
};

export default UiDayMoving;
